module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.7710/img/footerCmsFree.png"